import { render, staticRenderFns } from "./MyZone.vue?vue&type=template&id=2ecd3a1e&scoped=true&"
import script from "./MyZone.vue?vue&type=script&lang=js&"
export * from "./MyZone.vue?vue&type=script&lang=js&"
import style0 from "./MyZone.vue?vue&type=style&index=0&id=2ecd3a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd3a1e",
  null
  
)

export default component.exports